var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPythonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "python-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6441 27.2225V13.452C30.6441 7.41626 33.5819 0.262756 54.6893 0.262756H62.9605C74.5763 0.262756 88.4068 5.2255 88.4068 13.8991V45.8216C88.4068 50.1585 84.6102 58.072 76.0226 58.072C65.5784 58.072 52.113 58.072 44.3842 58.1167C39.4901 58.1451 26.9831 61.7829 26.9831 73.9886V88.9215H14.7345C9.62712 88.8321 0 84.3165 0 65.762V55.0765C0 47.1629 2.44068 30.8887 17.7627 30.8887H59.5706V27.2225H30.6441ZM43.3899 9.0705C36.2034 9.0705 35.7966 19.9796 43.3899 19.9796C50.6215 19.9796 50.5763 9.0705 43.3899 9.0705Z",
    fill: "url(#paint0_linear_21_519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclude_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7513 88.9662V92.5429H88.6778V104.436C88.6778 109.845 81.2654 120.263 62.2823 120.263H57.627C48.949 120.263 30.8247 116.149 30.8247 104.436V74.8827C30.8247 70.8142 35.8417 61.6934 44.61 61.6934H75.0733C83.9321 61.6934 92.2484 56.7754 92.2484 45.7769V30.8439H104.316C107.842 30.8439 113.02 32.99 115.796 39.9647C119.231 48.5936 120 56.4147 120 61.7829C120 65.5384 117.559 88.9662 103.367 88.9662H59.7513ZM76.097 99.8306C68.9105 99.8306 68.5038 110.74 76.097 110.74C83.3286 110.74 83.2834 99.8306 76.097 99.8306Z",
    fill: "url(#paint1_linear_21_519)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_519",
    x1: 36.6857,
    y1: 7.13427,
    x2: 65.659,
    y2: 60.8169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991945,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_519",
    x1: 75.4285,
    y1: 62.6091,
    x2: 106.929,
    y2: 103.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonLogo);
export default __webpack_public_path__ + "static/media/python-logo.7adddf2e877c43cc21e91ea300cb55d8.svg";
export { ForwardRef as ReactComponent };